import { render, staticRenderFns } from "./PlayableCard.vue?vue&type=template&id=032babfd&scoped=true"
import script from "./PlayableCard.vue?vue&type=script&lang=js"
export * from "./PlayableCard.vue?vue&type=script&lang=js"
import style0 from "./PlayableCard.vue?vue&type=style&index=0&id=032babfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032babfd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WordActions: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordActions/WordActions.vue').default,DefinitionContent: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/Definition/DefinitionContent.vue').default})
